"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.35
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusToJSON = exports.UserStatusFromJSONTyped = exports.UserStatusFromJSON = exports.UserStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["DEACTIVATED"] = "DEACTIVATED";
    UserStatus["DELETED"] = "DELETED";
    UserStatus["LOCKED"] = "LOCKED";
    UserStatus["PASSWORDCHANGEREQUIRED"] = "PASSWORD_CHANGE_REQUIRED";
    UserStatus["PENDINGREACTIVATION"] = "PENDING_REACTIVATION";
    UserStatus["PENDINGACTIVATION"] = "PENDING_ACTIVATION";
    UserStatus["UNKNOWN"] = "UNKNOWN";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
function UserStatusFromJSON(json) {
    return UserStatusFromJSONTyped(json, false);
}
exports.UserStatusFromJSON = UserStatusFromJSON;
function UserStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.UserStatusFromJSONTyped = UserStatusFromJSONTyped;
function UserStatusToJSON(value) {
    return value;
}
exports.UserStatusToJSON = UserStatusToJSON;
